<template>
  <div class="invoices">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Official — Instagram Content Publishing</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item">
                    <router-link to="/instagram/accounts/list">List Accounts</router-link>
                  </li>
                  <li class="breadcrumb-item active">Add Account</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- /Search Filter -->
          <div class="row">
            <div class="col-md-12 col-lg-6 col-xl-6 d-flex">
              <div class="card flex-fill">
                <div class="card-body">
                  <h4 class="card-title">Content Publishing</h4>
                  <div class="statistics">
                    <p
                      class="text-muted"
                    >You can use the Instagram Graph API to publish single images, videos, reels (i.e. single media posts), or posts containing multiple images and videos (carousel posts) on Instagram Business accounts.</p>
                    <h4 class="card-title">Limitations</h4>
                    <ul class="text-muted">
                      <li>Instagram Creator accounts are not supported.</li>
                      <li>Accounts are limited to 25 API-published posts within a 24 hour period. Carousels count as a single post.</li>
                      <li>JPEG is the only image format supported.</li>
                      <li>Stories are not supported.</li>
                      <li>Shopping tags are not supported.</li>
                      <li>Publishing to Instagram TV is not supported.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12 col-lg-6 col-xl-6 d-flex">
              <div class="card container">
                <div class="row align-items-center h-100">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>
                        Brand:
                        <span class="text-danger">*</span>
                      </label>
                      <div class="form-group">
                        <multiselect
                          v-model="selectedContact"
                          id="ajax"
                          label="brand_name"
                          track-by="id"
                          :placeholder="'Type to search Brand...'"
                          :multiple="true"
                          open-direction="bottom"
                          :custom-label="customLabel"
                          :options="contactOptions"
                          :searchable="true"
                          :loading="isLoading"
                          :internal-search="false"
                          :close-on-select="false"
                          :options-limit="300"
                          :limit="3"
                          :limit-text="limitText"
                          :max-height="600"
                          :show-no-results="true"
                          :hide-selected="true"
                          @search-change="asyncFind"
                          :show-labels="false"
                        >
                          <template slot="tag" slot-scope="{ option, remove }">
                            <span class="custom__tag">
                              <span>{{option.name}}</span>
                              <span class="custom__remove" @click="remove(option)">❌</span>
                            </span>
                          </template>
                          <template slot="clear" slot-scope="props">
                            <div
                              class="multiselect__clear"
                              v-if="selectedContact.length"
                              @mousedown.prevent.stop="clearAll(props.search)"
                            ></div>
                          </template>
                          <span slot="noResult">Oops! No elements found.</span>
                        </multiselect>
                      </div>
                    </div>
                    <div class="text-center" v-if="selectedContact.length">

                      <div v-if="loadingFB" style="margin-top:20px;">Sedang mengalihkan...</div>
                      <div v-else>
                        <v-facebook-login
                          v-if="FBComponent.scope.logout && FBComponent.model.connected"
                          v-model="FBComponent.model"
                          type="button"
                          :style="'width:100%;margin-top:10px;'"
                          :app-id="FBComponent.appId"
                          :use-alt-logo="true"
                          class="btn-default-costume btn-facebook"
                          tabindex="6"
                          @sdk-init="handleSdkInit"
                          @login="handleSdkLogin"
                          :version="'v16.0'"
                          :login-options="FBComponent.scopeInstagramPermissionsInsight"
                        />
                        <v-facebook-login
                          v-else
                          v-model="FBComponent.model"
                          v-slot:login
                          type="button"
                          tabindex="6"
                          :style="'width:100%;margin-top:10px;'"
                          :app-id="FBComponent.appId"
                          :use-alt-logo="true"
                          class="btn-default-costume btn-facebook"
                          @sdk-init="handleSdkInit"
                          @login="handleSdkLogin"
                          :version="'v16.0'"
                          :login-options="FBComponent.scopeInstagramPermissionsInsight"
                        >Masuk Dengan Facebook</v-facebook-login>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">&nbsp;</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>

    <!-- {{selectedContact}} -->
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import VFacebookLogin from "vue-facebook-login-component";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
    Multiselect,
    VFacebookLogin
  },
  data() {
    return {
      loadingFB: false,
      FBComponent: {
        version: process.env.VUE_APP_FACEBOOK_API_VERSION,
        appId: process.env.VUE_APP_FACEBOOK_APP_ID,
        FB: {},
        model: {},
        scope: {
          scope:
            "pages_show_list,instagram_basic,instagram_manage_comments,instagram_manage_insights,instagram_content_publish,instagram_manage_messages,public_profile"
        }
      },
      selectedContact: [],
      contactOptions: [],
      contactListParam: {
        id: "",
        name: "",
        page: 0,
        perPage: 20
      },
      isLoading: false,
      formParam: {
        copy: false,
        brand_id: [],
        ig: {
          id: "",
          username: "",
          password: ""
        }
      }
    };
    //  isactive : true
  },
  computed: {},
  watch: {
    selectedContact: {
      handler: function(val, oldVal) {
        // console.log("selectedLicense", val, oldVal);
        // if (val != oldVal) {
        if (val.length > 0) {
          this.formParam.brand_id = [];
          this.selectedContact.forEach((row, idx) => {
            this.formParam.brand_id.push(row.id);
          });
          return;
        }
        if (val != oldVal && oldVal.length == 1 && val.length < 1) {
          this.selectedContact = [];
          this.formParam.brand_id = [];
          return;
        }
      },
      deep: true
    }
  },
  created() {},
  methods: {
    async handleSdkLogin(res) {
      if (res.status === "connected") {
        var accessToken = res.authResponse.accessToken;
        console.log("accessToken:", accessToken);
        this.loadingFB = await true;
        var that = await this;
        await this.FBComponent.FB.api(
          "/me?fields=id,email,name,picture,first_name,last_name",
          async function(data) {
            console.log("data:", data);
            this.loadingFB = await false;
          }
        );
      } else {
        // alert(res.status);
        this.$fire({
          title: "Error",
          text: res.status,
          type: "error",
          timer: 2000
        }).then(r => {});
        this.loadingFB = await false;
      }
    },
    async handleSdkInit({ FB, scope }) {

      // console.log("scope::", scope)
      this.FBComponent.FB = FB;
      this.FBComponent.scope = scope;
    },
    limitText(count) {
      return `and ${count} other`;
    },
    customLabel({ name }) {
      return `${name}`;
    },
    asyncFind(query) {
      this.isLoading = true;
      this.contactListParam.name = query;
      this.contactListParam.id = "";
      this.$store
        .dispatch("brand/list", this.contactListParam)
        .then(response => {
          this.isLoading = false;
          this.contactOptions = response.data.data;

          // console.log("contactOptions", this.contactOptions);
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    asyncFindSelect(query, id) {
      this.isLoading = true;
      this.contactListParam.name = query;
      this.contactListParam.id = id;

      this.$store
        .dispatch("brand/list", this.contactListParam)
        .then(response => {
          this.isLoading = false;
          this.contactOptions = response.data.data;
          if (id != "") {
            if (this.contactOptions.length > 0) {
              this.selectedContact = this.contactOptions[0];
            }
          }
          // console.log("contactOptions", this.contactOptions);
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    clearAll() {
      this.selectedContact = [];
    }
  },
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "officialContentPublishing"
};
</script>


// WEBPACK FOOTER //
// src/views/instagram/instagramAccount/officialContentPublishing.vue